<template>
  <div>
    <ContentSkeleton v-if="loading" variant="form" :rows="6" />
    <template v-else>
      <div class="row g-3">
        <div class="col-md-6">
          <label class="form-label" for="outlookClientId">{{ $t("outlook.clientId") }}</label>
          <input
            id="outlookClientId"
            v-model="form.outlookClientId"
            type="text"
            class="form-control font-monospace small"
            autocomplete="off"
            :disabled="saving"
          />
        </div>
        <div class="col-md-6">
          <label class="form-label" for="outlookTenantId">{{ $t("outlook.tenantId") }}</label>
          <input
            id="outlookTenantId"
            v-model="form.outlookTenantId"
            type="text"
            class="form-control font-monospace small"
            placeholder="common"
            autocomplete="off"
            :disabled="saving"
          />
        </div>
        <div class="col-md-6">
          <label class="form-label" for="outlookClientSecret">{{ $t("outlook.clientSecret") }}</label>
          <input
            id="outlookClientSecret"
            v-model="form.outlookClientSecret"
            type="password"
            class="form-control font-monospace small"
            autocomplete="new-password"
            :placeholder="clientSecretConfigured ? '••••••••' : ''"
            :disabled="saving"
          />
        </div>
        <div class="col-md-6">
          <label class="form-label" for="outlookRedirectUri">{{ $t("outlook.redirectUri") }}</label>
          <input
            id="outlookRedirectUri"
            v-model="form.outlookRedirectUri"
            type="url"
            class="form-control font-monospace small"
            autocomplete="off"
            :disabled="saving"
          />
        </div>
      </div>
      <p class="small text-muted mt-2 mb-3">{{ $t("outlook.settingsHint") }}</p>
      <button type="button" class="btn btn-primary btn-sm" :disabled="saving" @click="save">
        <i v-if="saving" class="fas fa-spinner fa-spin me-1" aria-hidden="true"></i>
        {{ $t("Save") }}
      </button>
    </template>
  </div>
</template>

<script>
import { wencesApi } from "@/api/wencesApi";
import Swal from "sweetalert2";
import ContentSkeleton from "@/components/common/ContentSkeleton.vue";

export default {
  name: "OutlookSettings",
  components: { ContentSkeleton },
  props: {
    embedded: { type: Boolean, default: false },
  },
  data() {
    return {
      loading: true,
      saving: false,
      clientSecretConfigured: false,
      form: {
        outlookClientId: "",
        outlookClientSecret: "",
        outlookRedirectUri: "",
        outlookTenantId: "common",
      },
    };
  },
  async mounted() {
    await this.load();
  },
  methods: {
    async load() {
      this.loading = true;
      try {
        const { data } = await wencesApi.get("/api/outlook/settings");
        const s = data.settings || {};
        this.form.outlookClientId = s.outlookClientId || "";
        this.form.outlookRedirectUri = s.outlookRedirectUri || "";
        this.form.outlookTenantId = s.outlookTenantId || "common";
        this.form.outlookClientSecret = "";
        this.clientSecretConfigured = !!s.clientSecretConfigured;
      } catch (err) {
        Swal.fire({
          icon: "error",
          title: this.$tn("Error") || "Error",
          text: err?.response?.data?.error || err.message,
        });
      } finally {
        this.loading = false;
      }
    },
    async save() {
      this.saving = true;
      try {
        const payload = {
          outlookClientId: this.form.outlookClientId,
          outlookRedirectUri: this.form.outlookRedirectUri,
          outlookTenantId: this.form.outlookTenantId,
        };
        if (this.form.outlookClientSecret) {
          payload.outlookClientSecret = this.form.outlookClientSecret;
        }
        await wencesApi.put("/api/outlook/settings", payload);
        Swal.fire({
          icon: "success",
          title: this.$tn("outlook.saved") || "Guardado",
          timer: 1800,
          showConfirmButton: false,
        });
        await this.load();
      } catch (err) {
        Swal.fire({
          icon: "error",
          title: this.$tn("Error") || "Error",
          text: err?.response?.data?.error || err.message,
        });
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>
